module.exports = __webpack_public_path__ + "img/WhatsApp90694873.a086ef94.png";